module.exports = __webpack_public_path__ + "OpenSans-BoldItalic-7be88e73fea7b64568a450d7c01346b0.woff";